import React              from 'react';
import usePOST            from 'rest/usePOST';
import useStyles          from 'components/CommonForm/commonFormStyles';
import { useTranslation } from 'react-i18next';

import Alert         from 'components/Alert';
import CommonForm    from 'components/CommonForm';
import COMMON_FIELDS from 'components/CommonForm/fields';
import Container     from '@mui/material/Container';
import Paper         from '@mui/material/Paper';
import Typography    from '@mui/material/Typography';

import { BACKEND_PATHS }   from 'rest/const';
import { getErrorMessage } from 'rest/sendRequest';

const FIELDS = {
  username: {
    ...COMMON_FIELDS.username,
  },
};


function RegisterPage() {

  const { t }       = useTranslation();
  const { classes } = useStyles();

  const [alert,           setAlert]           = React.useState(undefined);
  const [submitData,      setSubmitData]      = React.useState(undefined);
  const [successRegister, setSuccessRegister] = React.useState(false);

  const swrOpts = {
    onSuccess: (res) => {
      setSubmitData(null);
      setSuccessRegister(true);
      setAlert({
        msgTranslKey: 'emailWasSent',
        type:         'success',
      });

      if (process.env.NODE_ENV === 'development') {
        console.log('RegisterPage, onRestSuccess: ', res.data);
      }
    },
    onError: (err) => {
      setSubmitData(null);
      //TODO? add more specific handling when API is developed
      setAlert({
        msgTranslKey: 'serverError',
        type:         'warning',
      });

      if (process.env.NODE_ENV === 'development') {
        console.log('RegisterPage, onRestError: ', getErrorMessage(err), err.response);
        console.error('RegisterPage, onRestError: ', err);
      }
    },
  };

  const REGISTER_PATH = submitData ? BACKEND_PATHS.register : null; //null = don't send
  const REGISTER_POST = usePOST(REGISTER_PATH, submitData, undefined, swrOpts);

  function handleSubmit(evt) {
    evt.preventDefault();
    setAlert(null);
    const formData      = new FormData(evt.target);
    const toBeSubmitted = {
      type: 'EMAIL', //Might be a SelectField in the future
    };

    for (const [key, value] of formData.entries()) {
      toBeSubmitted[key] = value;
    }

    setSubmitData(toBeSubmitted); //TODO? add encryption?
  }

  function submitBtnTooltipFn() {
    if (REGISTER_POST.isValidating) {
      return t('inProgress');
    } else if (successRegister) {
      return t('emailWasSent');
    }
    return '';
  }

  return (
    <Container maxWidth='xs'>
      <Alert alert={alert} setAlert={setAlert}/>
      <Paper elevation={6} className={classes.mainPaper}>
        <Paper elevation={0} className={classes.titlePaper}>
          <Typography
            align='center'
            variant='subtitle1'
            className={classes.title}
          >
            {t('registerTitle')}
          </Typography>
        </Paper>
        <CommonForm
          t={t}
          fields={FIELDS}
          onSubmit={handleSubmit}
          submitBtnText='registerButton'
          submitBtnTooltipFn={submitBtnTooltipFn}
          everythingDisabled={REGISTER_POST.isValidating || successRegister}
        />
      </Paper>
    </Container>
  );
}

export default RegisterPage;